import React, { Fragment } from 'react'

import {
  number, string, object, bool, func, array, oneOfType,
} from 'prop-types'

import { EMPTY_ARRAY, EMPTY_OBJECT } from 'Utils/stableDefaults'

import ModelDetailsTable from './Components/ModelDetailsTable/ModelDetailsTable'
import VerifiedModelTable from './Components/VerifiedModelTable'
import ModelInfoSidebarFooter from './ModelInfoSidebarFooter'
import ShortModelInfo from './ShortModelInfo'

function ModelInfoSidebar({
  isLoading,
  title,
  id,
  modelRating = 0,
  modelRatingCount = 0,
  reviewCount = 0,
  commentCount = 0,
  likeCount = 0,
  viewCount = 0,
  priceInfo,
  username = null,
  userPicture = null,
  userRating = 0,
  modelUrl,
  handleWishlist,
  isWishlistAvailable,
  isOnWishlist,
  isWishListActionLoading = false,
  isCartActionLoading = false,
  tags = EMPTY_ARRAY,
  currentSelectedFileTypes,
  setSelectedFilters,
  trackFilterChange,
  types = EMPTY_OBJECT,
  polygons,
  vertices,
  handleCart,
  isCartAvailable,
  isOnCart,
  textures = false,
  materials = false,
  uvwMapping = false,
  pluginsUsed = false,
  cgtVerification = EMPTY_OBJECT,
  isPurchased = false,
  isCgtStandardThresholdReached = false,
  showCgtVerification,
  itemAttributes,
}) {
  return (
    <div className="cgt-model-gallery-new__sidebar js-gallery-sidebar">
      <div className="cgt-model-gallery-new__sidebar-content">
        <ShortModelInfo
          title={title}
          modelRating={modelRating}
          modelRatingCount={modelRatingCount}
          commentCount={commentCount}
          likeCount={likeCount}
          viewCount={viewCount}
          priceInfo={priceInfo}
        />
        {!isLoading && (
          <Fragment>
            <ModelDetailsTable
              currentSelectedFileTypes={currentSelectedFileTypes}
              setSelectedFilters={setSelectedFilters}
              trackFilterChange={trackFilterChange}
              tags={tags}
              types={types}
              polygons={polygons}
              vertices={vertices}
              textures={textures}
              materials={materials}
              uvwMapping={uvwMapping}
              pluginsUsed={pluginsUsed}
            />
            {showCgtVerification && isCgtStandardThresholdReached && (
              <VerifiedModelTable cgtVerification={cgtVerification} />
            )}
          </Fragment>
        )}
      </div>
      <ModelInfoSidebarFooter
        id={id}
        username={username}
        userPicture={userPicture}
        reviewCount={reviewCount}
        userRating={userRating}
        modelUrl={modelUrl}
        handleWishlist={handleWishlist}
        isWishlistAvailable={isWishlistAvailable}
        isOnWishlist={isOnWishlist}
        isWishListActionLoading={isWishListActionLoading}
        handleCart={handleCart}
        isCartAvailable={isCartAvailable}
        isOnCart={isOnCart}
        isCartActionLoading={isCartActionLoading}
        isPurchased={isPurchased}
        itemAttributes={itemAttributes}
      />
    </div>
  )
}

ModelInfoSidebar.propTypes = {
  isLoading: bool.isRequired,
  title: string.isRequired,
  id: string.isRequired,
  likeCount: number,
  modelRating: number,
  modelRatingCount: number,
  reviewCount: number,
  commentCount: number,
  viewCount: number,
  priceInfo: object.isRequired,
  username: string,
  userPicture: string,
  userRating: number,
  modelUrl: string.isRequired,
  isOnWishlist: bool.isRequired,
  handleWishlist: func.isRequired,
  isWishlistAvailable: bool.isRequired,
  isWishListActionLoading: bool,
  isCartActionLoading: bool,
  tags: array,
  currentSelectedFileTypes: array.isRequired,
  setSelectedFilters: func.isRequired,
  trackFilterChange: func.isRequired,
  types: object,
  polygons: oneOfType([number, string, bool]),
  vertices: oneOfType([number, string, bool]),
  handleCart: func.isRequired,
  isCartAvailable: bool.isRequired,
  isOnCart: bool.isRequired,
  textures: bool,
  materials: bool,
  uvwMapping: bool,
  pluginsUsed: bool,
  cgtVerification: object,
  isPurchased: bool,
  isCgtStandardThresholdReached: bool,
  showCgtVerification: bool.isRequired,
  itemAttributes: object.isRequired,
}

export default ModelInfoSidebar
